import { API } from "@aws-amplify/api";


export const getAckDetails = `query MyQuery($input: cidInput!) {
    bolDetails(input: $input){
        customerDetails {
          subTitle
          title
          section {
            dataItems {
              label
              value
            }
            rowItems {
              label
              value
            }
            subTitle
            title
          }
        }
        serviceDates {
          subTitle
          title
          section {
            dataItems {
              label
              value
            }
            subTitle
            title
            rowItems {
              label
              value
            }
          }
        }
        moverCarrier {
          subTitle
          title
          section {
            subTitle
            title
            rowItems {
              label
              value
            }
            dataItems {
              label
              value
            }
          }
        }
  }
  moveChargesService(input: $input) {
    chargesService {
      title
      subTitle
      section {
        subTitle
        title
        dataItems {
          highlight
          hasSubContent
          label
          subText
          value
        }
      }
    }
    moveDetails {
      title
      subTitle
      section {
        dataItems {
          hasSubContent
          label
          subText
          value
        }
      }
    }
    estimateTypeBinding {
      subTitle
      title
      section {
        dataItems {
          hasSubContent
          label
          subText
          value
        }
        rowItems {
          hasSubContent
          label
          subText
          value
        }
      }
    }
  }
  getAckDetails(input: $input) {
    section {
      dataItems {
        hasSubContent
        label
        subText
        value
      }
      rowItems {
        hasSubContent
        label
        subText
        value
      }
      subTitle
      title
    }
    order
    subTitle
    title
  }
  }`;




export async function getBolandMoveDetails(cid: any): Promise<any> {
  try {

    const response: any = await API.graphql({
      query: getAckDetails, variables: {
        input: {
          customerId: cid
        }
      }
    });
    return response.data;
  } catch (error) {
    console.log("getMilesBasedOnZipCode Query lno:34 Error:", error);
  }
}
